<template>
    <div>
        <zm-button type="primary" plain @click="showCreate" v-if="hasPermission">Create</zm-button>
        <zm-table :data="list.slice((pageable.page - 1) * pageable.size, pageable.page * pageable.size)">
            <zm-table-column label="Name" prop="name"></zm-table-column>
            <zm-table-column label="Type" prop="type"></zm-table-column>
            <zm-table-column label="Source" prop="source"></zm-table-column>
            <!-- <zm-table-column label="Url" prop="url"></zm-table-column> -->
            <zm-table-column label="Enable" prop="enable">
                <template slot-scope="scope">
                    <i :class="scope.row.enable ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                </template>
            </zm-table-column>
            <zm-table-column v-if="hasPermission">
                <template slot-scope="scope">
                    <zm-button type="icon" class="zm-icon-edit" @click="showEdit(scope.row)" :loading="scope.row.editLoading"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" title="change status" :icon="scope.row.enable ? 'zm-icon-pause' : 'zm-icon-play'"
                    @click="changeStatus(scope.row)"></zm-button>
                    <zm-button type="icon" class="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next"
                :total="list.length">
            </zm-pagination>
        </div>
        <zm-dialog :visible.sync="visible" :title="form.title">
            <zm-form label-width="110px" label-position="left" :model="form" ref="form" :rules="rules">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="notificationchannel-name"></tip>
                    </div>
                    <zm-input v-model.trim="form.name" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="type" prop="type">
                    <div slot="label">
                        <tip label="type" id="notificationchannel-type"></tip>
                    </div>
                    <zm-select v-model="form.type" clearable size="small" style="width: 100%">
                        <zm-option v-for="item in typeList" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="Source">
                    <div slot="label">
                        <tip label="Source" id="notificationchannel-source"></tip>
                    </div>
                    <zm-input v-model="form.source" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="url"
                v-if="form.type === 'IM' || form.type === 'Webhook'" prop="url">
                    <div slot="label">
                        <tip label="Url" id="notificationchannel-url"></tip>
                    </div>
                    <zm-input v-model="form.url" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="authorization"
                v-if="form.type === 'IM' || form.type === 'Webhook'" prop="authorization">
                    <div slot="label">
                        <tip label="Authorization" id="notificationchannel-authorization"></tip>
                    </div>
                    <zm-input v-model="form.authorization" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enable" size="small">
                        <tip label="enable" id="notificationchannel-enable"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import {
    listNotificationChannel,
    getNotificationChannelById,
    deleteNotificationChannel,
    createNotificationChannel,
    updateNotificationChannel,
    updateNotificationChannelStatus
} from '@/api/monitorManager'
import tip from 'components/ToolTip/index'
export default {
    name: 'notificationChannel',
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            loading: false,
            visible: false,
            typeList: ['IM', 'Webhook', 'Email', 'Incident'],
            form: {
                title: '',
                id: '',
                name: '',
                type: '',
                source: '',
                url: '',
                authorization: '',
                enable: false
            },
            pageable: {
                page: 1,
                size: 10
            },
            rules: {
                name: [
                    { required: true, message: 'please select name', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: 'please select type', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: 'please select url', trigger: 'blur' }
                ],
                authorization: [
                    { required: true, message: 'please select authorization', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const { title, id, name, type, source, url, authorization, enable } = this.form
                    const data = { name, type, source, url, authorization, enable }
                    if (title === 'Create Notification Channel') {
                        this.loading = true
                        createNotificationChannel(data).then(response => {
                            this.$message.success('Create success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (title === 'Edit Notification Channel') {
                        this.loading = true
                        updateNotificationChannel(id, data).then(response => {
                            this.$message.success('Update success')
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        showCreate () {
            this.form.title = 'Create Notification Channel'
            this.form.id = ''
            this.form.name = ''
            this.form.type = ''
            this.form.source = ''
            this.form.url = ''
            this.form.authorization = ''
            this.form.enable = false
            this.visible = true
        },
        showEdit (row) {
            this.form.title = 'Edit Notification Channel'
            row.editLoading = true
            getNotificationChannelById(row.id).then(res => {
                this.form.url = res.url
                this.form.id = row.id
                this.form.name = row.name
                this.form.type = row.type
                this.form.source = row.source
                this.form.authorization = row.authorization
                this.form.enable = row.enable
                this.visible = true
                row.editLoading = false
            }).catch(() => {
                row.editLoading = false
            })
        },
        changeStatus (row) {
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                const data = {
                    active: !row.enable
                }
                this.loading = true
                updateNotificationChannelStatus(row.id, data).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message.success('Change status success!')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message.info('Change canceled')
            })
        },
        showDelete (id) {
            this.$confirm('This will delete the notification channel. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteNotificationChannel(id).then(response => {
                    this.loading = false
                    this.$message.success('Delete success!')
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message.info('Delete canceled')
            })
        },
        fetchData () {
            this.loading = true
            listNotificationChannel().then(response => {
                this.list = response.map(item => {
                    item.editLoading = false
                    return item
                })
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
